import { useQuery } from '@tanstack/react-query';
import {
  adaptiveScanningPollInterval,
  type ApplicationsContract,
} from '@terra/shared-contracts-applications';
import { applicationsClient } from '@terra/shared-rest-clients-applications';
import { terraApiWrapper } from '../../utils/terraApiWrapper';

export const ADAPTIVE_SCANNING_STATE_QUERY_KEY = 'adaptive-scanning-state';

export const useAdaptiveScanningState = ({
  applicationId,
  enabled = true,
}: {
  applicationId?: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: [ADAPTIVE_SCANNING_STATE_QUERY_KEY, applicationId],
    queryFn: () =>
      terraApiWrapper<typeof ApplicationsContract.getAdaptiveScanningState>({
        endpointFn: () =>
          applicationsClient.getAdaptiveScanningState({
            params: { id: applicationId ?? '' },
          }),
      }),
    enabled: enabled && Boolean(applicationId),
    refetchInterval: (query) =>
      adaptiveScanningPollInterval({ state: query.state.data }),
  });
};
